// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"article-list_wrapper__rL0NZ","title":"article-list_title__GunAc"};